module.exports = __webpack_public_path__ + "static/ankit-81cb7087f982a14c6de6a866a2813f9f.jpg";